/**
 * Logo da unidade da sessão (sai no cabeçalho das folhas impressas).
 *
 *   GET    /api/unidade-atual/logo  → { logo: dataURI|null, nome_unidade, pode_editar, atualizado_em }
 *   PUT    /api/unidade-atual/logo  (multipart, campo `arquivo`)
 *   DELETE /api/unidade-atual/logo
 *
 * O logo vem como data URI de propósito: imagem de outro domínio "suja" o
 * canvas do html2canvas e o PDF sairia sem ela.
 */
import { useCallback, useEffect, useState } from "react";

import { useAuth } from "../context/AuthContext";

const ENDPOINT = "/api/unidade-atual/logo";
const VAZIO = { logo: null, nomeUnidade: "", podeEditar: false, atualizadoEm: null };

function paraEstado(resposta) {
  return {
    logo: resposta?.logo || null,
    nomeUnidade: resposta?.nome_unidade || "",
    podeEditar: Boolean(resposta?.pode_editar),
    atualizadoEm: resposta?.atualizado_em || null,
  };
}

export default function useLogoUnidade() {
  const { request } = useAuth();
  const [estado, setEstado] = useState(VAZIO);
  const [carregado, setCarregado] = useState(false);
  const [erro, setErro] = useState(null);

  const recarregar = useCallback(async () => {
    try {
      setEstado(paraEstado(await request(ENDPOINT, { silentError: true })));
      setErro(null);
    } catch (falha) {
      setErro(falha?.message || "Não foi possível ler o logo da unidade.");
    } finally {
      setCarregado(true);
    }
  }, [request]);

  useEffect(() => {
    recarregar();
  }, [recarregar]);

  const enviar = useCallback(async (arquivo) => {
    const corpo = new FormData();
    corpo.append("arquivo", arquivo);
    const resposta = await request(ENDPOINT, { method: "PUT", body: corpo, silentError: true });
    setEstado(paraEstado(resposta));
  }, [request]);

  const remover = useCallback(async () => {
    await request(ENDPOINT, { method: "DELETE", silentError: true });
    setEstado((atual) => ({ ...atual, logo: null, atualizadoEm: null }));
  }, [request]);

  return { ...estado, carregado, erro, recarregar, enviar, remover };
}
